import * as React from 'react';

import {
  withEnvironment,
  InjectedEnvironmentProps,
} from '@wix/yoshi-flow-editor';

import {
  ListLayoutProps as LayoutProps,
  ListLayoutItemProps,
  OnDocumentClick,
} from '../Layout.types';
import { ListLayoutItem } from './ListLayoutItem';

import { st, classes } from './ListLayout.st.css';

export interface ListLayoutProps
  extends LayoutProps,
    InjectedEnvironmentProps {}

class ListLayoutComp extends React.Component<ListLayoutProps> {
  static defaultProps: Partial<ListLayoutProps> = {
    renderItem: (props, key) => {
      return <ListLayoutItem key={key} {...props} />;
    },
  };

  render() {
    const { environment, renderItem, ...formatterProps } = this.props;
    const { isEditorX, isCssPerBreakpoint, isMobile } = environment;
    return (
      <ul
        className={st(classes.root, {
          mobileView: isMobile,
          fluid: isEditorX || isCssPerBreakpoint,
        })}
        data-hook="list-layout"
        ref={this.props.listRef}
        tabIndex={-1}
        aria-label={this.props.label}
      >
        {this.props.items.map((item, index) => {
          const handleLinkClick: OnDocumentClick = (e, clickOrigin) =>
            this.props.onItemLinkClick?.(e, item, index, clickOrigin);

          const listItemProps: ListLayoutItemProps = {
            ...formatterProps,
            item,
            onLinkClick: handleLinkClick,
          };

          return renderItem ? renderItem(listItemProps, item.id) : null;
        })}
      </ul>
    );
  }
}

export const ListLayout = withEnvironment(ListLayoutComp);
